<template>
    <p class="subheadline">Weitere Einstellungen</p>
    <div>
        <label for="billingViaEmail" class="checkbox">
            <input type="checkbox" id="billingViaEmail"
                   :checked="billingViaEmail"
                   @change="$emit('update:billingViaEmail', $event.target.checked)" />
            Rechnung kostenfrei per E-Mail erhalten
        </label>
    </div>
    <div>
        <label for="subscribeToNewsletter" class="checkbox">
            <input type="checkbox" id="subscribeToNewsletter"
                   :checked="subscribeToNewsletter"
                   @change="$emit('update:subscribeToNewsletter', $event.target.checked)" />
            Ich willige ein, dass gourmetta regelmäßig News zu Aktionswochen und Angeboten sowie Informationen zum Unternehmen an meine angegebene E-Mail-Adresse schickt
        </label>
    </div>
    <div>
        <label for="acceptedTermsAndConditions" class="checkbox">
            <input type="checkbox" id="acceptedTermsAndConditions" required
                   :checked="acceptedTermsAndConditions"
                   @change="$emit('update:acceptedTermsAndConditions', $event.target.checked)" />
            Hiermit bestätige ich, dass ich die <a href="https://gourmetta.de/agb/" target="_blank">AGBs</a>, <a href="https://gourmetta.de/datenschutz/" target="_blank">Widerrufserklärung</a> und die <a href="https://gourmetta.de/datenschutz/" target="_blank">Datenschutzbestimmung</a> akzeptiere
        </label>
    </div>
</template>

<script>

export default {
    name: 'RegisterFormPartOptionsAndTermsAndCondition',
    props: {
        billingViaEmail: Boolean,
        subscribeToNewsletter: Boolean,
        acceptedTermsAndConditions: Boolean,
    },
    emits: [
        'update:billingViaEmail',
        'update:subscribeToNewsletter',
        'update:acceptedTermsAndConditions',
    ],
}
</script>
